export default __webpack_public_path__ + "static/media/createjob-desk.e781db5a.svg";